<template>
  <div>
    <div v-if="!isPopupMode">
      <h3 class="font-medium text-m1 mr-24">
        {{ titleForBasicUsers }}
      </h3>
      <CheckmarkList :tips="recruitSitterTipsForBasicUsers" />
    </div>
    <p v-else-if="recruitSitterTipsForBasicUsers.length > 0" class="text-body text-gray-body mb-16">
      {{ recruitSitterTipsForBasicUsers[0] }}
    </p>
    <Dropdown id="job-dropdown" v-model="selectedJobOption" class="mt-16" labelName="Job" name="job" :options="jobOptions" />
    <Button value="Invite to Apply" variant="primary" size="medium" class="w-full mt-24" @click="handleRecruit" />
    <Button
      :value="upgradeMessage"
      variant="outlined"
      size="medium"
      class="w-full mt-24"
      to="/upgrade/pricing?source=recruit-sitter"
    />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';

export default {
  name: 'RecruitBasicJobs',
  components: {
    Button,
    CheckmarkList,
    Dropdown,
  },
  props: {
    recruitSitterTipsForBasicUsers: {
      required: true,
      type: Array,
    },
    titleForBasicUsers: {
      required: true,
      type: String,
    },
    upgradeMessage: {
      required: true,
      type: String,
    },
    jobOptions: {
      type: Array,
      default: () => [],
    },
    selectedJob: {
      type: String,
      default: '',
    },
    recruit: {
      type: Function,
      default: () => {},
    },
    isPopupMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedJobOption: this.selectedJob,
    };
  },
  watch: {
    selectedJob(newValue) {
      this.selectedJobOption = newValue;
    },
    selectedJobOption(newValue) {
      this.$emit('update:selectedJob', newValue);
    },
  },
  methods: {
    handleRecruit() {
      this.$emit('recruitClicked', this.selectedJobOption);
    },
  },
};
</script>
